import { Dictionary } from '@meshwatch/types/dist/common';
import * as Yup from 'yup';

import { FormErrors, ValidationResponse } from './types';

export const typeErrorHandler = (name: string, params: Partial<Yup.TestMessageParams>): string => {
  return `${name} object expected but got: \`${params.originalValue}\``;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function validate<T extends Dictionary<any>>(
  schema: Yup.ObjectSchema<Yup.Shape<object, T>>,
  payload: T,
  options: Yup.ValidateOptions = { abortEarly: false, strict: true }
): Promise<ValidationResponse<T>> {
  if (payload === undefined || typeof payload === 'function') {
    // eslint-disable-next-line @typescript-eslint/no-object-literal-type-assertion
    const errors = { non_field_errors: `Object expected but got: \`${payload}\`` } as FormErrors<T>;
    return Promise.resolve({
      error: true,
      errors,
    });
  }

  return schema
    .validate(payload, options)
    .then(_ => ({
      error: false as false,
    }))
    .catch((err: Yup.ValidationError) => {
      const initialValue: FormErrors<T> = {};
      return {
        error: true,
        errors: err.inner.reduce((acc, validationError) => {
          let keyPath: keyof T = validationError.path;
          if (keyPath === undefined) {
            keyPath = 'non_field_errors';
          }
          acc[keyPath] = validationError.message;
          return acc;
        }, initialValue),
      };
    });
}
